var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('plus-header',{class:_vm.flag ? '' : 'header-hide',attrs:{"new-msg-notice":_vm.notice,"message-interval":60,"get-user-info":_vm.user}})
}
var staticRenderFns = []

export { render, staticRenderFns }